import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { listNotifications, markRead } from "./api";

export const useNotifications = () =>
  useQuery({ queryKey: ["notifications"], queryFn: listNotifications });

export const useUnreadCount = (): number => {
  const { data } = useNotifications();
  return data?.unread ?? 0;
};

export function useMarkRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => markRead(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["notifications"] }),
  });
}
